import { Component, Input, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/services/utils.service';

export interface ConfirmModel {
  dataFraude: any;
  reportesRegCheq?: any;
  reportesBlackList?: any;
}

@Component({
  selector: 'app-modal-fraude-salfa',
  templateUrl: './modal-fraude-salfa.component.html',
  styleUrls: ['./modal-fraude-salfa.component.scss']
})
export class ModalFraudeSalfaComponent /*implements AfterViewInit*/ {
  public objectKeys = Object.keys;
  public tablaRegCheq: any[] = [];
  public tablaListaNegra: any[] = [];
  public expandedRegCheq: boolean = false;
  public expandedListaNegra: boolean = false;

  @Input() dataFraude: any = {};

  confirmData: ConfirmModel = {
    //printable: false,
    dataFraude: {},
    reportesRegCheq: null,
    reportesBlackList: null
  };

  public counter$: Observable<number> = new Observable;
  public counter = 0;

  constructor(
    public dialogRef: MatDialogRef<ModalFraudeSalfaComponent>,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel
  ) {
    this.confirmData = data;
    if(this.confirmData?.reportesRegCheq && this.confirmData?.reportesRegCheq.length > 0) {
      this.mapDataRegCheq();
    }

    if(this.confirmData?.reportesBlackList && this.confirmData?.reportesBlackList.length > 0) {
      this.mapDataBlackList();
    }
  }

  close() {
    this.dialogRef.close(false);
  }

  mapDataRegCheq() {
    // obj = rut, ruc, delito, riesgo
    for(const itemRut of this.confirmData?.reportesRegCheq) {
      const rut = itemRut.rut || "";
      if(itemRut?.regCheq?.listas?.secondCriminalCasesChile?.data?.additionalData && itemRut?.regCheq?.listas?.secondCriminalCasesChile?.data?.additionalData.length > 0) {
        const additionalData = itemRut?.regCheq?.listas?.secondCriminalCasesChile?.data?.additionalData || [];
        for(const item of additionalData) {
          const riesgo = item?.riesgo || "";
          if(riesgo && riesgo.toUpperCase().includes("HIGH")) { // solo incluir casos de riesgo alto
            if(!this.tablaRegCheq.some(e => e.ruc == item?.ruc && e.rut == rut)) { // evitar duplicados por RUC por cada RUT
              
              const rutElements = additionalData.filter((e: any) => e.ruc == item?.ruc);
              const fechaMasReciente = this.getFecha(rutElements, 'desc');
              const fechaMasAntigua = this.getFecha(rutElements, 'asc');

              const obj: any = {
                rut: rut,
                ruc: item?.ruc || "",
                delito: item?.crimen || "",
                riesgo: this.utilsService.riskMapping(item?.riesgo) || "",
                fechaInicial: fechaMasAntigua,
                fechaUltimoMov: fechaMasReciente
              };
              this.tablaRegCheq.push(obj);
            }
          }
        }
      }
    }
  }

  mapDataBlackList(): void {
    for(const item of this.confirmData?.reportesBlackList) {
      const obj: any = {
        rut: item?.rut || "",
        nombre: item?.nombre || "",
        lineaNegocios: item?.linea_negocios || "",
        fechaRegistro: item?.fecha_registro || ""
      };

      this.tablaListaNegra.push(obj);
    }
  }

  getFecha(rutElements: any[], order: 'asc' | 'desc'): string {
    if (!Array.isArray(rutElements) || rutElements.length === 0) {
      return '';
    }

    const elementosValidos = rutElements
      .filter(el => {
        const fecha = el?.fecha || el?.fecha_ingreso || null;

        if (!fecha || typeof fecha !== 'string') return false;

        const partes = fecha.split('/');
        if (partes.length !== 3) return false;

        const [dia, mes, anio] = partes.map((p: any) => parseInt(p, 10));
        if (
          isNaN(dia) || isNaN(mes) || isNaN(anio) ||
          dia < 1 || dia > 31 ||
          mes < 1 || mes > 12 ||
          anio < 1000
        ) {
          return false;
        }

        const fechaObj = new Date(anio, mes - 1, dia);
        return !isNaN(fechaObj.getTime());
      })
      .sort((a, b) => {
        const fechaA = a.fecha || a.fecha_ingreso;
        const fechaB = b.fecha || b.fecha_ingreso;

        const [da, ma, ya] = fechaA.split('/').map((p: any) => parseInt(p, 10));
        const [db, mb, yb] = fechaB.split('/').map((p: any) => parseInt(p, 10));

        if (order === 'asc') {
          return new Date(ya, ma - 1, da).getTime() - new Date(yb, mb - 1, db).getTime();
        } else {
          return new Date(yb, mb - 1, db).getTime() - new Date(ya, ma - 1, da).getTime();
        }
      });

    return elementosValidos.length > 0 ? (elementosValidos[0].fecha || elementosValidos[0].fecha_ingreso) : '';
  }

}
